import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from '@services/appstate.service';
import { Observable } from 'rxjs';
import { getCropResolutionEntities } from '../../reducers';

import JSZip from 'jszip';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-bulk-download-dialog',
  templateUrl: './bulk-download-dialog.component.html',
  styleUrls: ['./bulk-download-dialog.component.scss']
})
export class BulkDownloadDialogComponent implements OnInit {
  selectedImages: Array<any> = [];
  imageAmount = 0;

  cropResolutions$: Observable<any>;
  cropResolutions: any;
  cropData: any = [];

  displayedColumns = ['Name', 'Path', 'Size', 'Actions'];
  selectedIds: any = [];

  busy = false;

  constructor(
    private store: Store<AppState>,
    private matDialogRef: MatDialogRef<any>,
    private httpClient: HttpClient
  ) {
    const profile = JSON.parse(localStorage.getItem('profile'));
    if (profile['https://mediaspirit.io/app_metadata'] != null) {
      if (profile['https://mediaspirit.io/app_metadata'].rights) {
        if (profile['https://mediaspirit.io/app_metadata'].rights.indexOf('multipleSourceDownload') > -1) {
          this.cropData.push({
            description: 'Source',
            path: 'source/source',
            url: 'source',
            _id: '42069'
          });
        }
      }
    }

    this.cropResolutions$ = this.store.pipe(getCropResolutionEntities());
    this.cropResolutions$.subscribe(x => {
      this.cropResolutions = x;
      for (const key of Object.keys(this.cropResolutions)) {
        if (this.cropResolutions[key].outputExtension !== 'webp') {
          this.cropData.push(this.cropResolutions[key]);
        }
      }
    });
  }

  ngOnInit() {
    this.selectedImages = this.matDialogRef.componentInstance.selectedImages;
    this.imageAmount = this.matDialogRef.componentInstance.imageAmount;
  }

  checkSelectedCrops(crop: any) {
    if (this.selectedIds != null && this.selectedIds.length > 0) {
      for (const id of this.selectedIds) {
        if (crop.id === id) {
          return true;
        }
      }
    }
    return false;
  }

  selectCrop(crop: any) {
    const index = this.selectedIds.indexOf(crop.id);
    if (index > -1) {
      this.selectedIds.splice(index, 1);
    } else {
      this.selectedIds.push(crop.id);
    }
  }

  selectCrops() {
    if (this.selectedIds.length >= this.cropData.length) {
      this.selectedIds = [];
    } else {
      for (const crop of this.cropData) {
        this.selectedIds.push(crop.id);
      }
    }
  }

  roundNumber(width: any, ratio: any, image: any) {
    if (ratio === 0) {
      return Math.round(width / (image.width / image.height));
    } else {
      return Math.round(width / ratio);
    }
  }

  async closeDialog() {
    this.busy = true;
    const fileObj: any = {};
    for (const id of this.selectedIds) {
      if (id === '42069') {
        fileObj['Source'] = [];
      } else {
        fileObj[this.cropResolutions[id].description] = [];
      }
      for (const image of this.selectedImages) {
        if (id === '42069') {
          fileObj['Source'].push(
            {
              url: `https://sd9cksc8i8.execute-api.eu-central-1.amazonaws.com/prod/image/source/${image.id}?token=${localStorage.getItem('id_token')}`,
              name: image.nlCleanUrl.replace('/', '')
            }
          );
        } else {
          fileObj[this.cropResolutions[id].description].push(
            {
              url: this.cropResolutions[id].url + '/' + this.cropResolutions[id].path + image.nlCleanUrl,
              name: image.nlCleanUrl.replace('/', '')
            }
          );
        }
      }
    }
    await this.createZip(fileObj, 'MediaSpirit Images');
    this.matDialogRef.close();
  }

  async createZip(fileObj: any, zipName: string) {
    let zip: JSZip = new JSZip();
    const name = zipName + '.zip';
    // tslint:disable-next-line:prefer-for-of
    for (const folder of Object.keys(fileObj)) {
      for (const folderObj of fileObj[folder]) {
        const fileData: any = await this.getFile(folderObj.url);
        const b: any = new Blob([fileData], { type: '' + fileData.type + '' });
        zip.folder(folder).file(folderObj.name, b, { binary: true, createFolders: true });
      }
    }
    zip.generateAsync({ type: 'blob' }).then((content: any) => {
      if (content) {
        FileSaver.saveAs(content, name);
      }
    });
    this.busy = false;
  }

  async getFile(url: string) {
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    const res = await this.httpClient.get(url, httpOptions).toPromise().catch((err: HttpErrorResponse) => {
      const error = err.error;
      return error;
    });
    return res;
  }
}
